
import React from "react";
import SelectInput from './SelectInput';
import TextInput from './TextInput';
import saveFile from "../services/saveFile";
import Cookies from 'universal-cookie';
import uuid from 'react-uuid';
import Constants from "../utils/consts";
import Button from './Button';
import MyDatePicker from "./DatePickerIta";
import moment from 'moment';
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import './css/editor.css';
import ImageSilentInput from "./ImageSilentInput";
import translateString from "../utils/Locales";
import getClient from "../services/getClient";
import getRataStatus from "../services/getRataStatus";
import Utils from "../utils/utils";
import { NineCellLoading } from 'react-loadingg';
import emettiRicevuta from "../services/emettiRicevutaDaRata";
import setRataSent from "../services/setRataSent";

let tr = translateString;

export default class RataStatusWidget extends React.Component {

    constructor(props){
        super(props);

        this.rataDateRef = React.createRef();
        this.dataPagamentoRef = React.createRef();
        this.importoRef = React.createRef();
        this.selectMetodoRef = React.createRef();
        this.importo = 0;

        this.options = [];
        this.options.push({ value: 'NON PAGATA', label: tr('non_pagata_s')});
        this.options.push({ value: 'DA VERIFICARE', label: tr('DA VERIFICARE')});
        this.options.push({ value: 'PAGATA', label: tr('PAGATA')});
        this.files = [];
        this.newFiles = [];
        this.deletedFiles = [];
        this.newNote = undefined;
        this.dataPagamento = undefined;
        this.payOption = { value: 'MP0', label: tr('seleziona') };

        this.paymentOptions = [
            { value: 'MP0', label: tr('seleziona') },
            { value: 'MP19', label: tr('MP19') }, 
            { value: 'MP01', label: tr('MP01') }, 
            { value: 'MP08', label: tr('MP08') }, 
            { value: 'MP02', label: tr('MP02') }, 
        ];

        this.state = {
            option: { value: 'NON PAGATA', label: tr('non_pagata_s')},
            payOption: { value: 'MP0', label: tr('seleziona') }, 
            payedOnSdi: this.props.rata ? this.props.rata.rCompleta ? this.props.rata.rCompleta.inviata_sdi : false : false,
            count: 0,
            isLoading: true,
            sentUuid: undefined,
        }
    }

    onContentStateChange = contentState => {

        this.savedEnabled = true;
        this.setState({ contentState });
    }

    componentDidMount(){
        this.option = this.options.find(o => o.value == this.props.status);

        this.setState({
            option: this.option ? this.option : { value: 'NON PAGATA', label: tr('non_pagata_s') },
        });
    }

    async componentDidUpdate(prevProps) {
        if (JSON.stringify(prevProps.rata) != JSON.stringify(this.props.rata)) {

            console.log(this.props.rata);
            
            let cookies = new Cookies();
            let username = cookies.get('username', { path: '/' });
            let token = cookies.get('token', { path: '/' });

            this.setState({ isLoading: true });
            this.cliente = await getClient('', '', new Cookies().get('db', { path: '/' }));
            let rate = await getRataStatus(username, token, this.props.rata.corso.id, this.props.rata.studente.id);
            this.rata = rate.find((r) => r.id === this.props.rata.id);
            
            if (!this.rata) {
                let numeroRicevuta = parseInt(this.cliente.numero_ricevuta);
                let prefisso = this.cliente.prefisso_ricevuta;
                this.numero = (prefisso ? prefisso + '/' : '') + (numeroRicevuta + 1) + (this.cliente.append_anno === '1' ? '/' + moment().format('yyyy') : '' );
                
                this.option = this.options.find(o => o.value == this.props.status);
                this.importo = this.props.rata.importo;
                this.data = this.props.rata.data;
                this.dataPagamento = moment().format('DD/MM/yyyy');
                this.payOption = { value: 'MP0', label: tr('seleziona') };

                this.setState({option: this.option,
                    note: this.props.rata.note,
                    isLoading: false, 
                    sentUuid: undefined,
                    payedOnSdi: false,
                });
            } else {
                let numeroRicevuta = parseInt(this.cliente.numero_ricevuta);
                let prefisso = this.cliente.prefisso_ricevuta;
                this.numero = this.rata.n_fattura ? this.rata.n_fattura : (prefisso ? prefisso + '/' : '') + (numeroRicevuta + 1) + (this.cliente.append_anno === '1' ? '/' + moment().format('yyyy') : '' );
                
                this.option = this.options.find(o => o.value == this.props.status);
                this.importo = this.rata.importo;
                this.data = this.rata.data;
                this.dataPagamento = this.rata.data_pagamento ? this.rata.data_pagamento : moment().format('DD/MM/yyyy');
                let metodo = this.rata.metodo ? this.rata.metodo : 'MP0';
                this.paymentOptions.forEach((p) => {
                    if (p.value === metodo) {
                        this.payOption = { value: p.value, label: p.label };
                    }
                });

                this.setState({option: this.option,
                    note: this.rata.note,
                    isLoading: false, 
                    sentUuid: this.rata.uuid_sdi,
                    payedOnSdi: this.rata.inviata_sdi === '1',
                });
            }
        }

        this.newNote = undefined;
    }

    handlePdfClick() {
        
        let cookies = new Cookies();
        cookies.set('currentRata', this.props.rata.id, { path: '/' });

        window.open('/' + cookies.get('db', { path: '/' }) + '/#/billing/invoicePdf', '_blank');
    }

    async generateFatturaElettronica() {
        
        if (!this.props.rata.rCompleta.inviata_sdi === '0') return;
        if (!window.confirm(tr('conferma_invio_ric'))) return;
        var fattura = {};
        
        const cookies = new Cookies();
        let username = cookies.get('username', { path: '/' });
        let token = cookies.get('token', { path: '/' });
        let cliente = await getClient('', '', cookies.get('db', { path: '/' }));

        let rataStatus = await getRataStatus(username, token, this.props.rata.corso.id, this.props.rata.studente.id);
        if (!rataStatus) {
            Utils.showError(tr('no_rata'));
            return;
        } 

        let rata = rataStatus.find(r => r.id === this.props.rata.id);
        if (!rata) {
            Utils.showError(tr('no_rata'));
            return;
        }

        if (!cliente.piva) {
            Utils.showError(tr('no_piva'));
            return;
        }

        if (!cliente.regimeFiscale) {
            Utils.showError(tr('no_piva'));
            return;
        }

        if(!this.props.rata.studente.codiceFiscale) {
            Utils.showError(tr('no_cf'));
            return;
        }

        if(!this.props.rata.studente.indirizzo || !this.props.rata.studente.citta) {
            Utils.showError(tr('no_ind'));
            return;
        }

        if(this.payOption.value === 'MP0') {
            Utils.showError(tr('no_m_pag'));
            return;
        }

        this.setState({ isLoading: true });

        let imponibile = (100 * parseFloat(this.importo))/122;
        let iva = (imponibile * 0.22).toFixed(2);

        // Rata found, creating electronic bill

        fattura = {
            "fattura_elettronica_header": {
              "dati_trasmissione": {
                "id_trasmittente": {
                  "id_paese": "IT",
                  "id_codice": cliente.piva
                },
                "codice_destinatario": "0000000"
              },
              "cedente_prestatore": {
                "dati_anagrafici": {
                  "id_fiscale_iva": {
                    "id_paese": "IT",
                    "id_codice": cliente.piva
                  },
                  "anagrafica": {
                    "denominazione": cliente.ragioneSociale
                  },
                  "regime_fiscale": cliente.regimeFiscale
                },
                "sede": {
                  "indirizzo": cliente.indirizzo,
                  "cap": cliente.CAP,
                  "comune": cliente.citta,
                  "provincia": cliente.provincia,
                  "nazione": "IT"
                }
              },
              "cessionario_committente": {
                "dati_anagrafici": {
                  "codice_fiscale": this.props.rata.studente.codiceFiscale ? this.props.rata.studente.codiceFiscale : "",
                  "anagrafica": {
                    "nome": this.props.rata.studente.nome,
                    "cognome": this.props.rata.studente.cognome,
                  }
                },
                "sede": {
                  "indirizzo": this.props.rata.studente.indirizzo,
                  "cap": "00000",
                  "comune": this.props.rata.studente.citta,
                  "nazione": "IT"
                }
              }
            },
            "fattura_elettronica_body": [
              {
                "dati_generali": {
                  "dati_generali_documento": {
                    "tipo_documento": "TD01",
                    "divisa": "EUR",
                    "data": this.dataPagamento,
                    "numero": this.numero,
                    "causale": [
                      "Pagamento rata per corso di insegnamento nell'anno accademico corrente."
                    ]
                  }
                },
                "dati_beni_servizi": {
                  "dettaglio_linee": [
                    {
                      "numero_linea": 1,
                      "descrizione": "Pagamento rata per il corso " + this.props.rata.corso.name + " nell'anno accademico " + this.props.rata.corso.anno_accademico,
                      "quantita": "1.00",
                      "prezzo_unitario": String(imponibile.toFixed(2)),
                      "prezzo_totale": String(imponibile.toFixed(2)),
                      "aliquota_iva": "22.00"
                    }
                  ],
                  "dati_riepilogo": [
                    {
                      "aliquota_iva": "22.00",
                      "imponibile_importo": String(imponibile.toFixed(2)),
                      "imposta": String(iva),
                      "esigibilita_iva": "I"
                    }
                  ]
                },
                "dati_pagamento": [
                  {
                    "condizioni_pagamento": "TP02",
                    "dettaglio_pagamento": [
                      {
                        "modalita_pagamento": this.payOption.value,
                        "importo_pagamento": parseFloat(this.importo).toFixed(2)
                      }
                    ]
                  }
                ]
              }
            ]
          };

        let res = await emettiRicevuta(username, token, fattura);
        if (res.uuid) {
            await setRataSent(username, token, this.props.rata.id, res.uuid, this.numero, this.dataPagamento);
            this.setState({ payedOnSdi: true, sentUuid: res.uuid });
        } else {
            console.error(res);
            Utils.showError(tr('err_fattura'));
        }

        this.setState({ isLoading: false });
    }

    render() {

        if (this.props.rata == undefined) return <div />;

        this.files = [];
        var tempArr = this.props.rata.files ? this.props.rata.files.split(';') : [];
        for (var t of tempArr)
            if (t != '' && this.deletedFiles.indexOf(t) == -1) 
                this.files.push(t);
        for (var t of this.newFiles)
            if (t.src != '' && this.deletedFiles.indexOf(t.src) == -1)
                this.files.push(t.src);

        const that = this;
        const rataDataFormatted = moment(this.data, "DD-MM-yyyy").format("yyyy-MM-DD");
        
        return ( 

        <div key={Math.random()} style={{display: this.props.show == true ? 'block' : 'none'}}> 
            <div style={container} onClick={() => { this.setState({ visible: false }); this.props.onClose(); }}>
            <div style={mainClass} onClick={(e) => e.stopPropagation()}>
            { this.state.isLoading ? <NineCellLoading /> : (<div>
            <div style={closeBtn} onClick={() => {
                this.setState({visible: false});
                this.props.onClose();
            }}>
                <img alt="" src={ require('../images/close_icon.png')} style={{ width: 30, height: 30, cursor: 'pointer' }} />
            </div>

                {this.props.rata.studente && <div style={{ marginLeft: 5 }}>{tr('nome')}: {this.props.rata.studente.nome.replace(/\\/g, '') + ' ' + this.props.rata.studente.cognome.replace(/\\/g, '') }</div> }
                <div style={windowTitle}>{tr('corso')}: {this.props.rata.corso.name}</div>
                
                { this.state.payedOnSdi && (
                    <p style={{ color: 'green', fontWeight: 'bold', fontSize: 10, marginLeft: '5px' }}>{tr('fatt_inviata')}</p>
                )}

                <div style={{ marginLeft: '5px' }}>
                <MyDatePicker name={tr('data')} ref={this.rataDateRef} value={rataDataFormatted} onChange={data => {
                    this.data = data;
                    }
                }/>
                <TextInput ref={this.importoRef} readOnly={ this.rata && this.rata.inviata_sdi === '1' } name={tr('importo')} value={this.importo} onChange={(text) => { this.importo = text}} />
                
                </div>

                { this.props.isStudent && 
                (
                    <>
                    <div style={{ marginLeft: 5 }}>
                        <SelectInput key={Math.random()} 
                            value={this.state.option} 
                            name={tr('stato') + ":"} 
                            options={this.options} 
                            isMulti={false}
                            onChange={(option) => {
                                if (!this.rata || (this.rata.inviata_sdi === '0')) {
                                    this.setState({
                                        option: option
                                    });
                                }
                            }}
                        />
                    </div>

                <div style={{ marginLeft: 5 }}>
                    <TextInput key={Math.random()} name={tr('note')} value={this.newNote ? this.newNote : this.state.note} 
                        onChange={(text) => { this.newNote = text}
                    } />
                </div>

                <p style={{ marginLeft: 10, marginTop: 30, fontWeight: 'bold' }}>{tr('f_allegati')}</p>
                <div style={{width: '100%', display: 'inline-flex', flexDirection: 'column', overflowY: 'scroll', overflowX: 'hidden', marginLeft: '10px', marginBottom: 20 }}>
                
                {
                    this.files.map((file, ind) => {
                        return <div key={Math.random()} style={{ width: '300px', height: 45, boxShadow: '0px 1px 3px lightgrey',backgroundColor: '#F3F3F3', paddingTop: 5, paddingBottom: 5, paddingLeft: 20, paddingRight: 20, display: 'flex', flexDirection: 'row', justifyContent: 'space-between', borderRadius: 10, cursor: 'pointer', margin: 3  }}>
                            <div style={{ display: 'flex', flexDirection: 'row' }} onClick={() => window.open(file, '_blank')}>
                                    <img src={ require('../images/folder.png') } style={{ height: 30, width: 30, marginTop: 2.5 }} alt="File" />
                                    <p style={{ fontWeight: 'bold', color: 'darkgrey', marginLeft: 20, marginTop: 9, textTransform: 'none' }}>{tr('apri_file')} {ind + 1}</p>
                            </div> 
                            <img src={ require('../images/delete.png') } style={{ height: 20, width: 20, marginTop: 2.5, cursor: 'pointer', marginRight: 10, marginTop: 7 }} title={tr('elimina_immagine')} onClick={(e) => { 
                                        e.stopPropagation();  
                                        if (window.confirm(tr('elimina_immagine')) == false) return;
                                        this.deletedFiles.push(file);
                                        this.setState({});
                                    }} />
                        </div>
                    })
                }
                </div>
                <ImageSilentInput name={''} key={Math.random()} 
                    value={this.state.imageToLoad}
                    onChange={async (base64) => {
                    const photoId = uuid()
                    const cookies = new Cookies();
                    const token = cookies.get('token', { path: '/' });
                    const username = cookies.get('username', { path: '/' });

                    let retPhotoObj = await saveFile(username, token, photoId, base64);
                    const fileName = 'https://' + Constants.mainUrl + retPhotoObj.name;
                    this.newFiles.push({
                        id: photoId,
                        src: fileName,
                        width: 1,
                        height: retPhotoObj.height / retPhotoObj.width
                    });

                    this.setState({});
                    }} 
                />
                </>
                )}

                { (this.props.rata.id !== undefined && (this.props.status === 'PAGATA' || this.state.option.value === 'PAGATA')) && (
                    <div style={{ marginLeft: '5px' }}>

                        <p style={{ marginLeft: '5px', marginTop: 10, fontWeight: 'bold' }}>{tr('sez_p')}</p>
                        
                        <MyDatePicker readOnly={ this.rata && this.rata.inviata_sdi === '1' } name={tr('data_p')} ref={this.dataPagamentoRef} value={this.props.rata.rCompleta.data_pagamento ? moment(this.props.rata.rCompleta.data_pagamento, 'DD/MM/yyyy').format('yyyy-MM-DD') : moment().format('yyyy-MM-DD')} onChange={data => {
                            this.dataPagamento = data;
                        }
                        }/>
                        
                        { (this.cliente && this.cliente.fatturazione_attiva === '1') && <TextInput readOnly={this.props.rata.rCompleta.inviata_sdi === '1'} key={Math.random()} name={tr('n_ricevuta')} value={this.numero} 
                        onChange={(text) => { this.numero = text}} /> }

                        <SelectInput key={Math.random()} 
                            ref={this.selectMetodoRef}
                            value={this.payOption} 
                            name={tr('m_pagamento')} 
                            options={this.paymentOptions} 
                            isMulti={false}
                            onChange={(option) => {
                                if (this.rata && this.rata.inviata_sdi === '0') {
                                    this.payOption = option;
                                }
                            }}
                        />
                    </div>
                )}

                { this.props.rata.id !== undefined && 
                    <div style={{ width: '300px', height: '40px', border: '2px solid #db4655', borderRadius: '5px', marginLeft: 10, marginTop: 20, marginBottom: 10, display: 'flex', flexDirection: 'row', justifyContent: 'flex-start', cursor: 'pointer', paddingLeft: 20, paddingRight: 20, paddingTop: 7 }} onClick={this.handlePdfClick.bind(this)}>
                        <img src={ require('../images/pdf_bill.png') } style={{ height: 20, width: 20, marginTop: 1 }} />
                        <p style={{ marginLeft: 20, fontSize: 16, fontWeight: 'bold', color: '#db4655' }}>{tr('pdf_ricevuta')}</p>
                    </div>
                }

                { (this.cliente && this.cliente.fatturazione_attiva === '1' && this.props.rata.id !== undefined && this.state.option.value === 'PAGATA' && (this.props.rata.rCompleta.inviata_sdi === '0' && !this.state.payedOnSdi)) && 
                    <div style={{ width: '300px', height: '40px', border: '2px solid #6982EE', borderRadius: '5px', marginLeft: 10, marginTop: 10, marginBottom: 20, display: 'flex', flexDirection: 'row', justifyContent: 'flex-start', cursor: 'pointer', paddingLeft: 20, paddingRight: 20, paddingTop: 7 }} onClick={this.generateFatturaElettronica.bind(this)}>
                        <img src={ require('../images/invoice_send.png') } style={{ height: 20, width: 20, marginTop: 1 }} />
                        <p style={{ marginLeft: 20, fontSize: 16, fontWeight: 'bold', color: '#6982EE' }}>{tr('manda_ricevuta')}</p>
                    </div>
                }

                <br/>
                { (this.props.isInRitardo === undefined || !this.props.isInRitardo) && <Button callback={async () => {


                        if (String(this.importo).replace(/,/g, '.').includes('.')) {
                            Utils.showError(tr('errore_costo_int'));
                            return;
                        }

                        var filesString = '';
                        for (var str of this.files){
                            if (filesString != '') filesString = filesString + ';';
                            filesString = filesString + str;
                        }

                        var note = this.newNote != undefined ? this.newNote : this.state.note;
                        var rataDate = this.rataDateRef.current.getDate();
                        rataDate = (moment (rataDate).format("DD-MM-yyyy"));

                        var dataP = undefined;
                        if (this.props.rata.id && this.state.option.value === 'PAGATA') {
                            dataP = this.dataPagamentoRef.current.getDate();
                            dataP = moment(dataP).format('DD-MM-yyyy');
                        }

                        var rata = this.props.rata;
                        rata.id_corso = rata.corso.id;
                        rata.id_studente = rata.studente.id;
                        rata.importo = parseInt(this.importo);
                        rata.data = rataDate;
                        rata.note = note;
                        rata.files = filesString;
                        rata.status = this.state.option.value;
                        rata.dataPagamento = dataP;
                        rata.n_fattura = this.state.payedOnSdi ? this.numero : undefined;
                        rata.metodo =  this.payOption.value !== 'MP0' ? this.payOption.value : undefined;
                        rata.inviata_sdi = this.state.payedOnSdi ? "1" : "0";
                        rata.uuid_sdi = this.state.sentUuid ? this.state.sentUuid : undefined;

                        this.props.onClose(rata);
                }} title={tr('salva')}></Button> }
            </div>)}
            </div>
            </div>
        </div>
        )
    }


}

const windowTitle = {
    color: 'darkgrey', 
    fontSize: 30, 
    fontWeight: 'bold', 
    fontFamily: 'Teko', 
    textAlign:'left', 
    marginLeft: 5, 
}

const closeBtn = {
    position: 'absolute', 
    cursor: 'pointer',
    right: 10, 
    top: 10, 
    padding: 10, 
    zIndex: 999,
}

const container = {
    position: 'fixed', 
    display: 'block', 
    top: 0,
    left: 0, 
    bottom: 0, 
    right: 0,
    minWidth: '100%', 
    minHeight: '100%', 
    backgroundColor: '#3C3C3C4D',
    overflowY: 'scroll',
    overflowX: 'hidden',
};

const mainClass = {
    paddingBottom: 10, 
    position: 'absolute',
    left: 'calc((100% - 400px)/2',
    top: '100px',
    right: '35%',
    minWidth: '400px',
    width: '400px',
    background: 'white',
    padding: '20px',
    zIndex: 999,
    boxShadow: '0px 2px 10px darkgrey', 
    borderRadius: '10px',
    bottom: '30px',
    overflow: 'scroll',
}